import { IStackStyles, IStackTokens } from "@fluentui/react";
import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "../../../theme/customTheme";

export const metricCardHeaderTokens: IStackTokens = {
  childrenGap: 12,
};

export const metricCardHeaderStackStyles: IStackStyles = {
  root: {
    minWidth: 0,
    flex: 1,
  },
};

export const useStyles = makeStyles({
  metricCard: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  cardHeader: {
    alignItems: "flex-start",
    paddingBottom: designTokens.spacing[2],
  },
  gridCardHeader: {
    alignItems: "flex-start",
    paddingBottom: designTokens.spacing[3],
  },
  metricIcon: {
    flexShrink: 0,
    color: designTokens.accent[600],
    fontSize: "20px",
  },
  title: {
    whiteSpace: "normal",
    wordBreak: "break-word",
    lineHeight: designTokens.lineHeight.tight,
    color: designTokens.neutral[700],
  },
  tooltipIcon: {
    color: designTokens.neutral[500],
    cursor: "help",
  },
  metricContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  skeletonValue: {
    width: "80%",
  },
  value: {
    color: designTokens.neutral[900],
    marginBottom: designTokens.spacing[2],
  },
  gridCard: {
    maxWidth: "none",
  },
  gridContent: {
    paddingTop: designTokens.spacing[2],
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: designTokens.spacing[3],
  },
  gridSkeletonWide: {
    width: "90%",
  },
  gridSkeletonMedium: {
    width: "75%",
  },
  gridSkeletonNarrow: {
    width: "85%",
  },
});
